import React from 'react';
import { array, func, number, oneOfType, shape, string } from 'prop-types';
import { ShoppingBagFast } from '@magalu/stereo-ui-icons';
import { Button as ButtonComponent } from '../../../atoms';
import Image from '../../../atoms/ResponsiveImage';
import { ButtonTitle, Content, Display, ImageContainer, ProductCard, TitleDisplay } from '../showcase.styles';
import HighlightTitle from '../highlight-title';

const Button = ({
  data,
  button,
  title,
  titleAs,
  titleSize,
  imageAltPrefix,
  productTitleAs,
  onClick,
  onMouseDown
}) => {
  const [highlight] = data;
  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${highlight.title}` : highlight == null ? void 0 : highlight.title;
  return /*#__PURE__*/React.createElement(Display, {
    displayMode: "button",
    "data-testid": "product-card-container",
    hideLinkBorder: false,
    as: "div"
  }, /*#__PURE__*/React.createElement(HighlightTitle, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize
  }), /*#__PURE__*/React.createElement(ProductCard, null, /*#__PURE__*/React.createElement(ImageContainer, {
    displayMode: "list"
  }, /*#__PURE__*/React.createElement(Image, {
    src: highlight == null ? void 0 : highlight.image,
    alt: imageAlt,
    lazy: true,
    offset: 2
  })), /*#__PURE__*/React.createElement(Content, {
    displayMode: "none",
    "data-testid": "product-card-content"
  }, /*#__PURE__*/React.createElement(TitleDisplay, {
    as: productTitleAs
  }, /*#__PURE__*/React.createElement(ButtonTitle, null, highlight == null ? void 0 : highlight.title)))), /*#__PURE__*/React.createElement(ButtonComponent, {
    "data-testid": "showcase-button",
    onClick: e => onClick(e, highlight),
    onMouseDown: e => onMouseDown(e, highlight),
    color: "secondary",
    startIcon: /*#__PURE__*/React.createElement(ShoppingBagFast, {
      width: 32,
      height: 32
    }),
    m: '10px 0',
    full: true
  }, (button == null ? void 0 : button.label) || 'RETOMAR SUA COMPRA'));
};

process.env.NODE_ENV !== "production" ? Button.propTypes = {
  displayMode: string,
  data: array,
  button: shape({
    image: string
  }),
  title: string,
  titleAs: string,
  titleSize: oneOfType([string, number]),
  imageAltPrefix: string,
  productTitleAs: string,
  onClick: func,
  onMouseDown: func
} : void 0;
Button.defaultProps = {
  onMouseDown: () => {}
};
export default Button;